/*
 * @Date: 2023-02-15 15:28:50
 * @LastEditors: Leo
 * @LastEditTime: 2023-03-13 20:05:45
 * @FilePath: \3.0-manger\src\js\snippets\accordion-menu.js
 */
const Accordion = function(el, multiple) {
  this.el = el || {};
  // more then one submenu open?
  this.multiple = multiple || false;


  el.find(".submenuItems").first().slideToggle()
  el.find(".submenuItems").first().parent().addClass("open")


  var dropdownlink = this.el.find('.dropdownlink');
  dropdownlink.on('click', {
          el: this.el,
          multiple: this.multiple
      },
      this.dropdown);
};

Accordion.prototype.dropdown = function (e) {
  var $el = e.data.el,
      $this = $(this),
      $next = $this.next();

  $next.slideToggle();
  $this.parent().toggleClass('open');

  if (!e.data.multiple) {
      $el.find('.submenuItems').not($next).slideUp().parent().removeClass('open');
  }
}
export default Accordion
// var accordion = new Accordion($('.accordion-menu'), false);